import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const TimeToInvest = lazyWithPreload(() => import('./TimeToInvest'))
